import { FEATURE_FLAGS } from '@fordeer/feature-flags'

export const POSTHOG_API_KEY = import.meta.env.VITE_APP_PUBLIC_POSTHOG_KEY ?? ''
export const POSTHOG_HOST =
  import.meta.env.VITE_APP_PUBLIC_POSTHOG_HOST ?? 'https://app.posthog.com'

/**
 * Keep compatibility with existing env-driven flag key.
 * Fallback avoids hard crash when env is missing.
 */
export const FF_APP_INVOICE_NEW_DESIGN =
  import.meta.env.VITE_POSTHOG_FLAG ?? FEATURE_FLAGS.INVOICE.APP_NEW_DESIGN

export const FF_HELP_CENTER = FEATURE_FLAGS.INVOICE.HELP_CENTER
export const FF_SHOPIFY_FLOW = FEATURE_FLAGS.INVOICE.SHOPIFY_FLOW
export const FF_GUIDED_VIDEOS = FEATURE_FLAGS.INVOICE.GUIDED_VIDEOS
export const FF_EINVOICE_XML_EXPORT_UI =
  FEATURE_FLAGS.INVOICE.EINVOICE_XML_EXPORT_UI
export const FF_INVOICE_SUBSCRIPTION_DOWNGRADE_FLOW =
  FEATURE_FLAGS.INVOICE.SUBSCRIPTION_DOWNGRADE_FLOW
export const FF_NEW_ONBOARDING = FEATURE_FLAGS.INVOICE.NEW_ONBOARDING
/** PostHog: bật Edit code (theme builder, gallery, pricing, deep-link) — tách khỏi show_order_template */
export const FF_THEME_EDIT_CODE = FEATURE_FLAGS.INVOICE.THEME_EDIT_CODE
/** PostHog: hiển thị order template (Fordeer for Order) và các thao tác order document */
export const FF_SHOW_ORDER_TEMPLATE = FEATURE_FLAGS.INVOICE.SHOW_ORDER_TEMPLATE
export const FF_ENABLE_NEW_ORDER_DETAIL =
  FEATURE_FLAGS.INVOICE.ENABLE_NEW_ORDER_DETAIL
export const FF_VIRTUAL_TOUR = FEATURE_FLAGS.INVOICE.VIRTUAL_TOUR
